export const round = (number: number, precision = 0): number => {
  const factor = Math.pow(10, precision)

  return Math.round(number * factor) / factor
}

export const roundAmount = (n = 0, showCents = true) =>
  new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
    maximumFractionDigits: showCents ? 2 : 0,
  }).format(round(n, showCents ? 2 : 0))
